<template>
  <!-- <div v-if="Object.keys(profileData).length" id="user-profile"> -->
  <div>
    <b-card no-body class="mb-20">
      <div class="m-2">
        <b-row align-h="start" style=" align-items: center ;">
          <b-col class="" cols="*" lg="*" md="6" sm="*">
            <b-form-group label="Search" invalid-feedback="Search field">
              <b-form-input
                id="name-input"
                ref="name"
                placeholder="Enter name to search"
                required
                @input="changeKeyword()"
                v-model="searchQuery"
              />
            </b-form-group>
          </b-col>
          <b-col cols="*" lg="*" md="6" sm="*" class="text-right">
            <!-- style="display: flex; justify-content: flex-end" -->
            <b-button
              :variant="allButtonStyle"
              @click="changeUserType('all')"
              style="margin-left: 10px;"
            >
              <span class="text-nowrap">
                All
              </span>
            </b-button>
            <b-button
              :variant="talentButtonStyle"
              @click="changeUserType('talent')"
              style="margin-left: 10px;"
            >
              <span class="text-nowrap">Talent </span>
            </b-button>

            <b-button
              :variant="scoutButtonStyle"
              @click="changeUserType('scout')"
              style="margin-left: 10px;"
            >
              <span class="text-nowrap">Talent Scout </span>
            </b-button>
          </b-col>

          <!-- <b-col class="pl-2" cols="*" lg="*" md="*" sm="*"> </b-col>

          <b-col class="pl-2" cols="*" lg="*" md="*" sm="*"> </b-col> -->
        </b-row>
      </div>
    </b-card>
    <!-- <profile-header :header-data="profileData.header" /> -->

    <!-- profile info  -->
    <section id="profile-info">
      <b-row>
        <!-- about suggested page and twitter feed -->
        <!-- <b-col lg="3" cols="12" order="2" order-lg="1">
          <profile-about :about-data="profileData.userAbout" />
          <profile-suggested-pages :pages-data="profileData.suggestedPages" />
          <profile-twitter-feed :twitter-feed="profileData.twitterFeeds" />
        </b-col> -->
        <!--/ about suggested page and twitter feed -->

        <!-- post -->

        <b-col xl="3" lg="3" sm="12"></b-col>
        <b-col xl="6" lg="6" sm="12" cols="12" order="1" order-lg="2">
          <profile-post
            v-for="(posts, index) in items"
            :key="index"
            :posts="posts"
          />
        </b-col>
        <!-- post -->

        <!-- latest photos suggestion and polls -->
        <!-- <b-col lg="3" cols="12" order="3">
          <profile-latest-photos :latest-images="profileData.latestPhotos" />
          <profile-suggestion :suggestions="profileData.suggestions" />
          <profile-polls :polls-data="profileData.polls" />
        </b-col> -->
        <!--/ latest photos suggestion and polls -->

        <!-- load more  -->
        <b-col cols="12" order="4">
          <profile-bottom @loadmore="loadmore()" v-if="items.length != 0" />
          <h3 v-else class="text-center mt-2">No Posts Found</h3>
        </b-col>
        <!--/ load more  -->
      </b-row>
    </section>
    <!--/ profile info  -->
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BPagination,
  BFormInput,
  BButton,
  BBadge,
  BFormGroup,
} from "bootstrap-vue";

import ProfileHeader from "./ProfileHeader.vue";
import ProfileAbout from "./ProfileAbout.vue";
import ProfileSuggestedPages from "./ProfileSuggestedPages.vue";
import ProfileTwitterFeed from "./ProfileTwitterFeed.vue";
import ProfilePost from "./ProfilePost.vue";
import ProfileLatestPhotos from "./ProfileLatestPhotos.vue";
import ProfileSuggestion from "./ProfileSuggestion.vue";
import ProfilePolls from "./ProfilePolls.vue";
import profileBottom from "./profileBottom.vue";

/* eslint-disable global-require */
export default {
  props: ["id", "userID"],
  components: {
    BRow,
    BCol,
    BPagination,
    BCard,
    BFormInput,
    BButton,
    BBadge,
    BFormGroup,
    ProfileHeader,
    ProfileAbout,
    ProfileSuggestedPages,
    ProfileTwitterFeed,
    ProfilePost,
    ProfileLatestPhotos,
    ProfileSuggestion,
    ProfilePolls,
    profileBottom,
  },
  data() {
    return {
      profileData: {},
      items: [],
      page: 1,
      searchQuery: "",
      timeout: 0,
      usertype: "all",
      allButtonStyle: "success",
      talentButtonStyle: "outline-success",
      scoutButtonStyle: "outline-success",
    };
  },
  created() {
    this.$http.get("/profile/data").then((res) => {
      this.profileData = res.data;
    });
    console.log(this.$route.params.id, this.userID);
    this.loadmore();
  },
  methods: {
    loadmore() {
      console.log("djdsjd");
      this.page += 1;
      this.LoadData();
    },
    changeUserType(usertype) {
      this.usertype = usertype;
      this.searchQuery = "";
      this.allButtonStyle = usertype == "all" ? "success" : "outline-success";
      this.talentButtonStyle =
        usertype == "talent" ? "success" : "outline-success";
      this.scoutButtonStyle =
        usertype == "scout" ? "success" : "outline-success";
      this.LoadData();
    },
    changeKeyword() {
      this.usertype = "all";
      this.allButtonStyle = "success";
      this.talentButtonStyle = "outline-success";
      this.scoutButtonStyle = "outline-success";
      this.timeout = setTimeout(() => {
        this.LoadData();
      }, 1000);
    },
    LoadData() {
      var axios = require("axios");
      var config = {
        method: "get",
        url: `https://geotalent-backend-production.up.railway.app/api/Posts/MyCoordinatedPostsPagination`,
        params: {
          page: 1,
          keyword: this.searchQuery == "" ? undefined : this.searchQuery,
          usertype: this.usertype == "all" ? undefined : this.usertype,
        },
        headers: {
          Authorization: "bearer " + this.$store.state.userData.token,
          "Access-Control-Allow-Origin": "*",
        },
      };

      axios(config)
        .then((response) => {
          console.log(response);
          if (this.page == 0) {
            this.items.push(response.data.data);
          } else {
            this.items.length = 0;
            this.items.push(response.data.data);
          }
          console.log(this.items);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-profile.scss";

@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
